export enum DeviceRepairingState {
    NoAction = 0,
    RepeatPairing,
    ModifiedByExternal,
}
